<template>
    <div class="flex float-left vertical-center">
        <vs-button v-bind:id="'btn-row-verification-'+rowNumber" size="small" icon-pack="feather" icon="icon-file-text" @click="reviewRecord" color="dark"
                   class="mr-2"></vs-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ReviewTableAgGridComponent",
        data() {
            return {
                isConfigure: false,
                rowNumber : 0
            }
        },
        methods: {
            reviewRecord() {
                this.$root.$emit("review-from-ActionTableAgGridComponent", this.params.value)
            }
        },
        mounted() {
          this.rowNumber = this.params.data.no
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>